import Swiper, { Pagination } from "swiper";

const ImageBanner = class extends HTMLElement {
  breakpoint: number = 990;

  connectedCallback() {
    const fullLink = this.querySelector("[data-fulllink");

    const slider = this.querySelector(".mobile-slider");

    fullLink?.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-video-control")) {
        e.preventDefault();
        e.target.click();
      }
    });

    if (!slider) {
      this.querySelectorAll(".fade-in").forEach((item) => item.classList.add("active"));
      return;
    }

    const mobileSlider = document.createElement("div");
    mobileSlider.className = slider.className;

    const wrapper = document.createElement("div");
    const pagination = document.createElement("div");
    const singleCallout = this.querySelector(".single-callout .image-banner__content-wrap")?.cloneNode(true);

    mobileSlider.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    pagination.classList.add("banner-swiper-pagination");

    slider.querySelectorAll(".banner-item").forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("swiper-slide");
      wrapper.appendChild(clone);
    });

    mobileSlider.appendChild(wrapper);
    mobileSlider.appendChild(pagination);

    if (singleCallout) {
      singleCallout.classList.add("single-callout");
      mobileSlider.appendChild(singleCallout);
    }

    slider.parentNode?.appendChild(mobileSlider);

    new Swiper(mobileSlider, {
      speed: 400,
      loop: true,
      centeredSlides: true,
      modules: [Pagination],
      pagination: {
        el: ".banner-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    this.querySelectorAll(".fade-in").forEach((item) => item.classList.add("active"));
  }
};

customElements.define("image-banner", ImageBanner);
